import { withDevtools, withGlitchTracking } from '@angular-architects/ngrx-toolkit';
import { INITIAL_PORT_STORE_STATE, PortsStoreState } from '@navstation-portal/ports/data-model/ports';
import { signalStore, withHooks, withState } from '@ngrx/signals';
import { injectDispatch } from '@ngrx/signals/events';
import { PORTS_STORE_ID } from './constants';
import { portEvents } from './ports-events';
import { withPortEffects } from './with-ports-effects';
import { withPortReducer } from './with-ports-reducer';

export const PortsStore = signalStore(
  { providedIn: 'root' },
  withDevtools(PORTS_STORE_ID, withGlitchTracking()),
  withState<PortsStoreState>(INITIAL_PORT_STORE_STATE),
  withPortEffects(),
  withPortReducer(),
  withHooks(() => {
    const events = injectDispatch(portEvents);
    return {
      onInit: () => {
        events.fetchPorts();
      },
    };
  })
);
